export const API_URL = {
  baseURL: process.env.REACT_APP_API_NEW_SERVER_URI,
  // ServerURL: "http://72.167.33.207:3030",
  ServerURL: "https://innovierhealth.com",

  auth: {
    login: "authController/login",
    deleteUser: "authController/deleteUser",
    sendEmail:"authController/sendEmail",
    registerClinic: "clinic/clinicProfileRegister",
    forgotPassword: "authController/forgotPassword",
    ResetPassword: "authController/changeUserPassword",
    verifyOTP:"clinic/verifyOtp",
    resendOTP:"clinic/resendClinicOtp",
    verifyEmail:"clinic/verifyLink",
    verifyDoctorEmail:"doctor/verifyLink",
  },
  fileUpload: {
    file: "authController/uploadPost",
  },
  dashboard: {
    // getAlldashboard: "admin/getAllCountForAdminDashboard",
    getUpcomingAppointmentListByDate: "doctor/getUpcomingAppointmentListByDate"
  },
  clinicProfile: {
    getCLinicById: "clinic/clinicDetailsById",
  },
  // clinic ratting
  clinicRating: {
    ratingClinic: "clinic/getAllRating"
  },
  // bank details 
  bank: {
    AddBank: "clinic/addClinicBankDetails",
    BankDetailes: "clinic/getAllClinicBankDetails",
  },
  uploadCLinicContract: {
    uploadContract: "clinic/sendContract",
  },
  // doctor availability all flow
  doctorAvailability: {
    blockBySlot:"/doctor/blockDoctorAvailabilityByTimeSlot",
    blockDoctorAvailabilityByDate:"doctor/blockDoctorAvailabilityByDates",
    blockDoctorAvailabilityByRecurring:"doctor/blockDoctorAvailabilityByRecurring",
    getAllClinicDoctorList: "doctor/getAllDoctorList",
    addAvailability: "doctor/add_Availability",
    updateAvailability: "doctor/updateAvailability",
    // availabiltySlotListDoctorWise: "doctor/viewAllDoctorAvailabilityInClinic",
    availabiltySlotListDoctorWise: "doctor/viewAllDoctorAvailabilityInClinicIST",
    blockAvailabilityByDate: "doctor/blockClinicDoctorAvailabilityByDate",
    blockAvailabilityBySlot:
      "doctor/blockClinicDoctorAvailabilityByDateAndSlot",
    getAllclinicdoctorblock: "doctor/getAllClinicDoctorBlockList",
    restoreBlockAvailability:
      "doctor/restoreClinicDoctorAvailabilityByDateAndTimeSlot",
    deleteAvailability: "doctor/deleteAvailability",
    findDoctorAvailability: "doctor/findAllDoctorAvailabilityByClinicId",
    blockAvailability: "doctor/blockClinicDoctorAvailability"

  },
  // doctor add get all flow
  doctor: {
    addClinicDoctorId: "doctor/doctor_add_by_clinic", //not found
    doctoraddByClinicRegistration: "doctor/doctorProfileRegister",
    getDoctorEmailId: "doctor/findByEmail",
    getSpecialization: "admin/getSpecializationByType",
    addDoctorFees: "doctor/addDoctorFees_by_clinic",
    doctorBlockByClinic: "doctor/block_doctor",
    doctorProfile: "/doctor/get_doctor_profile",
    add_pre_appointment_questionNew: "/doctor/add_pre_appointment_questionNew",
    DOCTORDETAILES: "/doctor/doctorDetailsById",
    getAllPreAppointmentQuestionsById: "/doctor/getPreAppointmentQuestionsById",
    getPreAppointmentQuestions: "doctor/getPreAppointmentQuestions",
    getExpertiesById: "doctor/doctorExpertiseByDoctorId"
  },
  country: {
    getallCountry: "doctor/get_country",
    getCitiesByCountryId: "doctor/getCitiesByCountryId"

  },
  // job matching management
  Jobmatching_Management: {
    addjobrequirement: "clinic/addJobPosting",
    getalljobpost: "clinic/getAllClinicJobPost",
    Openclosejobpost: "clinic/blockJobPostClinic",
    getAllmyMatching: "clinic/matchingFilter",
    getAllDashbaordfiltermatching: "clinic/Dashboardfilter",
    getSpecializationbyclinicIdDas: "clinic/getSpecializationByClinicId",
    matchingBySpecializationDashboard: "doctor/Dashboardfilter",
  },
  Chart: {
    doctorsCountByClinic: "doctor/doctorsCountByClinic",
  },
  // static pages
  staticApi: {
    getAllPrivacyPolicyAndTermandCondition: "doctor/getTermAndCondAndPrivacyAndPolicy",
    getAllContactus: "admin/getContactUs",
  },
  // appointment list
  myAppointmentList: {
    appointmentList: "doctor/getMyAppointmentList",
    patientchangestatus:"doctor/patientStatusChange",
  },
  // patient list
  myPatientList: {
    patientList: "doctor/getClinicPatientAppointmentList",
  },
  // role
  role: {
    getAllRole: "admin/role/get_all_role",
    AddRole: "admin/role/add_role",
    getRoleById: "admin/role/findRoleById",
    RoleStatus: "admin/role/blockRole",
  },
  module: {
    getAllModule: "admin/module/get_all_module",
  },
  // staff
  staff: {
    getAllStaff: "admin/getAllAdmin",
    addStaff: "admin/addAdmin",
    getStaffById: "admin/getAdminByUserId",
    staffStatus: "admin/block_admin",
    changePassword: "admin/staffResetPassword",//not found
  },
  // Payment 
  payment: {
    getMyAppointment: "doctor/getMyAppointmentList", //not found
    accountSummery: "doctor/getAllTransactionList",
    DoctorInvoiceList: "doctor/getClinicTransactionList",
    DoctorInvoiceDownload: "doctor/getDoctorInvoiceDownload"
  },
  // notification
  notification: {
    getNotification: "doctor/getNotification"
  },

  subscription: {
    getAllSubscription: "admin/getAllSubscription",
    createPaypalOrder: "doctor/createOrderAndGetApprovalUrlForWeb",
    createPaypalOrderServer: "doctor/createOrderAndGetApprovalUrlForServer",
    createStripeOrderServer:"doctor/create-intent",
    processPayment: "doctor/processPayment",
    processConfirm:"doctor/confirm",
    addWalletNew: "doctor/addWalletNew"
  },
};
